// TODO: refactor this

import $ from 'jquery';
import { PublicClientApplication, LogLevel } from '@azure/msal-browser';
import { debugLog } from './enci.log.js';
import { tokenManager } from './enci.tokenManager.js';
import { getApiUrl } from './enci.config.js';

// ERROR HANDLING SUPPORT ////////////////////////////////////////////////////////////////////////////////////////////

const ERROR_MSG_01 = 'Error: No msal.account.keys: ';
const ERROR_MSG_02 = 'Error: No msal.account.keys with client ID: ';
const ERROR_MSG_03 = 'Error: Unable to parse msalWithClient';
const ERROR_MSG_04 = 'Error: Parsed value did not contain an accessToken ';
const ERROR_MSG_05 = 'Error: No value from a key containing /access scope';
const ERROR_MSG_06 = 'Error: Unable to parse finalValue';
const ERROR_MSG_07 = 'Error: No secret associated with finalValue';

// GENERAL CONFIG ////////////////////////////////////////////////////////////////////////////////////////////////////

const KEY_MS_ACCT = `msal.account.keys`;
const KEY_MS_TOKEN = `msal.token.keys`;

const MS_DOMAIN = 'login.microsoftonline.com';
const MS_CLIENT_ID = '299b6d98-0897-47e7-9210-08b4f0836dab'; // portal: a2fb4ed7-7567-4508-94e1-50b45c241b5e
// const MS_OBJECT_ID = '32d55e5c-9624-44f6-9f3e-4562b4b59fb1'; // portal: 32d55e5c-9624-44f6-9f3e-4562b4b59fb1
const MS_TENANT_ID = '45eede19-4f73-4d53-bc1f-9f968bf336f6';
const EN_REDIRECT_URI = `/oauth-redirect`;

const API_URL = getApiUrl();

export let username = '';
export let firstname = '';
let activeAccount = null;

let idToken;

// const loginRequest = {
//   scopes: ['openid', 'profile', 'User.Read', `api://${MS_CLIENT_ID}/Access`],
// };

const tokenRequest = acct => {
  return {
    scopes: ['openid', 'c', 'User.Read', `api://${MS_CLIENT_ID}/Access`],
    account: acct,
  };
};

const msalConfig = {
  auth: {
    clientId: MS_CLIENT_ID,
    authority: `https://${MS_DOMAIN}/${MS_TENANT_ID}`,
    redirectUri: EN_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage', // 'localStorage', 'sessionStorage', 'memoryStorage' // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    // tokenRenewalOffsetSeconds: 1000, // 5 minutes
    allowNativeBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        // debugLog('msalConfig >> level:', { obj: level });
        // debugLog('msalConfig >> message:', { obj: message });
        // debugLog('msalConfig >> containsPii:', { obj: containsPii });

        if (containsPii) {
          return;
        }

        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
  telemetry: {
    application: {
      appName: 'EN Browser Default',
      appVersion: '1.0.0',
    },
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Handles the OAuth redirect flow for authentication using MSAL (Microsoft Authentication Library).
 * This function should be called after a redirect from the authentication server to handle
 * the authentication response. It checks for a token response and manages user authentication state.
 * If there's no token response and no user is currently signed in, it triggers a login redirect.
 * On success, it may perform operations such as setting up the session or updating the UI with the user's information.
 *
 * @async
 * @function handleOAuthRedirect
 * @returns {Promise<void>} A promise that resolves when the handling of the OAuth redirect is complete.
 * This includes initializing MSAL, processing any authentication token received, handling user sign-in,
 * or triggering a new login redirect if necessary. The promise may reject with an error if there's an issue
 * during the process, such as a failure in token acquisition.
 *
 * @example
 * // Call this function on pages that could receive an OAuth redirect.
 * handleOAuthRedirect().then(() => {
 *   debugLog('OAuth redirect handling complete.');
 * }).catch(error => {
 *   console.error('Failed to handle OAuth redirect', error);
 * });
 */
export async function handleOAuthRedirect() {
  // debugLog('handleOAuthRedirect');
  await msalInstance.initialize();
  // debugLog('handleOAuthRedirect >> msalInstance:', msalInstance);

  // Return the promise chain so that the caller can await it
  return msalInstance
    .handleRedirectPromise()
    .then(handleResponse)
    .catch(err => {
      // Handle error
      console.error(err);
      if (err.errorMessage && err.errorMessage.indexOf('interaction_required') !== -1) {
        msalInstance.loginRedirect(); // Interaction required by the user
      }
    });
}

// Breaking out the handleResponse method from above to make it easier to test
async function handleResponse(tokenResponse) {
  if (!tokenResponse) {
    debugLog('handleResponse >> No token response');
    const accounts = msalInstance.getAllAccounts();
    // debugLog('handleResponse >> accounts:', accounts);

    // No user signed in, initiate redirect
    if (accounts.length === 0) {
      debugLog('handleResponse >> No user signed in, initiating redirect');
      return msalInstance.loginRedirect();
    } else {
      debugLog('handleResponse >> User signed in, acquiring token silently');
      activeAccount = accounts[0];
      debugLog('handleResponse >> activeAccount:', { obj: activeAccount });

      idToken = activeAccount.idToken;
      username = activeAccount.username;
      firstname = activeAccount.name.split(' ')[0];

      // debugLog('User is signed in, acquiring token silently.');
      await msalInstance.acquireTokenSilent(tokenRequest(activeAccount));
    }
  } else {
    debugLog('handleResponse >> Token response:', { obj: tokenResponse });
    idToken = tokenResponse.account.idToken;
    username = tokenResponse.account.username;
    firstname = tokenResponse.account.name.split(' ')[0];
    debugLog('handleResponse >> username:', { obj: username });
    debugLog('handleResponse >> firstname:', { obj: firstname });

    // Here you would typically do something with the tokenResponse,
    // such as setting up your application's session, updating UI, etc.
    await sendDataToServer(tokenResponse.account.idToken);
  }
}

// trying to pass this back to the blazor server
async function sendDataToServer(accessToken) {
  debugLog('sendDataToServer >> accessToken:', { obj: accessToken });

  fetch('/api/token', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token: accessToken }),
  })
    .then(response => response.json())
    .then(data => {
      debugLog('Token processed by server:', { obj: data });
      if (data.status === 'User authenticated') {
        window.location.reload(); // or use history.pushState to force reload of the component or page
      }
    })
    .catch(error => debugLog('Error sending token to server:', { obj: error }));
}

/**
 * Processes the redirect response from the authentication server using MSAL (Microsoft Authentication Library).
 * This function ensures the MSAL instance is initialized before attempting to handle the redirect promise.
 * It's intended to be used in scenarios where the application is receiving a redirect from the authentication
 * server with an authentication response. This is part of the authentication flow in single-page applications
 * using MSAL for handling user authentication with Azure Active Directory or Microsoft accounts.
 *
 * @async
 * @function handleRedirectPromise
 * @returns {Promise<void>} A promise that resolves once the redirect response is processed.
 * This involves initializing the MSAL instance and then handling the redirect promise which
 * processes the authentication response from the redirect. The function ensures that any required
 * setup or token processing is completed before proceeding with the application flow. In case of
 * errors during the redirect handling or initialization, the promise may reject.
 *
 * @example
 * // Use this function on the page that acts as the redirect URI for OAuth responses.
 * handleRedirectPromise().then(() => {
 *   debugLog('Redirect promise handled successfully.');
 * }).catch(error => {
 *   console.error('Error handling redirect promise', error);
 * });
 */
export async function handleRedirectPromise() {
  debugLog('handleRedirectPromise');
  await msalInstance.initialize();
  await msalInstance.handleRedirectPromise();
}

/**
 * Asynchronously retrieves an access token or secret from sessionStorage based on Microsoft Authentication Library
 * (MSAL) session storage structure.  This function looks for specific MSAL-related keys in sessionStorage, parses
 * stored data, and returns the required token for authentication purposes. It encapsulates the logic within a promise
 * to handle asynchronous storage access patterns and potential parsing operations.
 *
 * @async
 * @function localStorageAccessMs
 * @returns {Promise<string>} A promise that resolves with the retrieved token or secret necessary for authenticating
 * API requests. The function attempts to find either an access token or a secret based on the application's
 * authentication flow and storage structure. It handles various scenarios and errors, ensuring that a valid
 * token is returned if present.
 *
 * @example
 * // Usage example to retrieve a token and use it for API authentication.
 * localStorageAccessMs()
 *   .then(token => {
 *     // Use the token for API requests
 *     debugLog('Retrieved token:', token);
 *   })
 *   .catch(error => {
 *     // Handle errors, such as missing token or parsing issues
 *     console.error('Error retrieving token:', error);
 *   });
 */
export async function localStorageAccessMs() {
  // debugLog('localStorageAccessMs');
  return new Promise((resolve, reject) => {
    try {
      // First, get the value associated with msal.account.keys
      const msalAcctKeyValue = sessionStorage.getItem(KEY_MS_ACCT);

      // If we dont have local storage then throw an error
      if (!msalAcctKeyValue) {
        throw new Error(ERROR_MSG_01);
      }

      // Second, get the value associated with the msal.account.keys with client ID
      let msalWithClient = sessionStorage.getItem(`${KEY_MS_ACCT}.${MS_CLIENT_ID}`);

      // If we dont have a value associated with msal.account.keys with client ID
      // then try to get it from the msal.token.keys with client ID
      if (!msalWithClient) {
        msalWithClient = sessionStorage.getItem(`${KEY_MS_TOKEN}.${MS_CLIENT_ID}`);
      }

      // If we still dont have a value associated with msal.account.keys with client ID
      if (!msalWithClient) {
        throw new Error(ERROR_MSG_02);
      }

      let parsedValue;

      // If we found a value associated with msal.account.keys with client ID then parse it
      try {
        parsedValue = JSON.parse(msalWithClient);
      } catch (error) {
        throw new Error(`${ERROR_MSG_03}: ${error.message}`);
      }

      //   const accessToken = parsedValue.accessToken;
      const accessToken = parsedValue.idToken;

      if (!accessToken || accessToken.length === 0) {
        throw new Error(ERROR_MSG_04);
      }

      // If we have an access token then check if it has the /access scope
      // Make sure we dont have multiple scopes
      const accessScopeToken = accessToken.find(token => token.includes('/access'));

      if (accessScopeToken) {
        // If we have an access token with /access scope then use it
        return accessScopeToken;
      }

      // No access token with /access scope found
      const finalValue = sessionStorage.getItem(accessToken[0]);

      if (!finalValue) {
        throw new Error(ERROR_MSG_05);
      }

      try {
        parsedValue = JSON.parse(finalValue);
      } catch (error) {
        throw new Error(`${ERROR_MSG_06}: ${error.message}`);
      }

      const secret = parsedValue.secret;

      if (!secret) {
        throw new Error(ERROR_MSG_07);
      }

      //   return secret;
      resolve(secret); // Resolve the promise with the token
    } catch (error) {
      reject(error); // Reject the promise if any error occurs
    }
  });
}

export async function setDynamicAjaxRequestHeader() {
  $.ajaxSetup({
    beforeSend: async function (xhr) {
      const token = await tokenManager.getToken();
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    },
  });
}

// Method to sign out
export function signOut() {
  msalInstance.logoutRedirect({
    onRedirectNavigate: url => {
      // Optionally, perform additional actions before redirecting for logout
      // For example, you could clear session storage or perform UI clean-up
      debugLog('Redirecting to:', url);
      // Return true to proceed with the redirect
      return true;
    },
  });
}

// In your JS file
export function isUserAuthenticated() {
  // debugLog('isUserAuthenticated');
  return new Promise(resolve => {
    const exists = idToken !== 'undefined' && idToken !== null;
    resolve(exists);
  });
}

export async function getAuthHeader() {
  const token = await tokenManager.getToken();
  return { Authorization: `Bearer ${token}` };
}

export async function makeAuthenticatedRequest(endpoint, options = {}) {
  const authHeader = await getAuthHeader();

  const requestOptions = {
    ...options,
    headers: {
      ...options.headers,
      ...authHeader,
    },
    credentials: 'include',
  };

  const url = endpoint.startsWith('http') ? endpoint : `${API_URL}/${endpoint}`;

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error with authenticated request:', error);
    throw error;
  }
}

export async function makeUnauthenticatedRequest(endpoint, options = {}) {
  const requestOptions = {
    ...options,
    credentials: 'include', // Retains credentials for same-origin requests if needed
  };

  // TODO: reverify why this was necessary
  // const url = endpoint.startsWith('http') ? endpoint : `${API_URL}/${endpoint}`;

  try {
    const response = await fetch(endpoint, requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error with unauthenticated request:', error);
    throw error;
  }
}

export function setRoleFlags(isAdmin, isLotStatusTrackerEditor, isLotStatusTrackerViewer) {
  window.isAdmin = isAdmin;
  window.isLotStatusTrackerEditor = isLotStatusTrackerEditor;
  window.isLotStatusTrackerViewer = isLotStatusTrackerViewer;
};
